import PropTypes from 'prop-types';
import MarkdownContent from '@/common/components/MarkdownContent';

const ScriptArcPreview = ({ record }) => <MarkdownContent>{record?.script || ''}</MarkdownContent>;

ScriptArcPreview.propTypes = {
  record: PropTypes.shape({
    script: PropTypes.string,
  }),
};

ScriptArcPreview.defaultProps = {
  record: undefined,
};

export default ScriptArcPreview;
